import * as React from 'react';
import ActionsManager from '../ActionsManager';
import {OBJECT_TYPES_NAMES} from '../ActionsManagerConsts';
import {AmazonListingsActionsProps} from './AmazonListingsActionsConsts';

const AmazonListingsActions: React.SFC<AmazonListingsActionsProps> = props => {
  return <ActionsManager objectType={OBJECT_TYPES_NAMES.AMAZON_LISTING} {...props} />;
};

export default AmazonListingsActions;
